import * as React from 'react'
import { Input, Root, Label } from './SingleLineInput.styles'

type Props = {
  className?: string,
  disabled?: boolean,
  id: string,
  isTouched?: boolean,
  isValid?: boolean,
  label?: string,
  onChange: Function,
  placeholder?: string,
  validationMessage?: string,
  value: string,
  [propName: string]: any, // for rest of parameters
}

const SingleLineInput = ({
  className,
  disabled,
  id,
  isTouched,
  isValid,
  label,
  onChange,
  placeholder,
  validationMessage,
  value,
  ...rest
}: Props): React.ReactElement => {
  let validationClass = ''
  if (isTouched && !isValid && validationMessage) {
    validationClass = 'invalid'
  }

  return (
    <Root className={`${className || ''} ${validationClass}`} {...rest}>
      {label && <Label htmlFor={id}>{label}</Label>}
      <Input
        type="text"
        id={id}
        value={value}
        placeholder={placeholder}
        onChange={e => onChange(e.target.value)}
        disabled={disabled}
        className={validationClass}
        data-testid="single-line-input"
        {...rest}
      />
    </Root>
  )
}

SingleLineInput.defaultProps = {
  placeholder: '',
  isValid: true,
  isTouched: false,
  disabled: false,
}

export default SingleLineInput
